export default __webpack_public_path__ + "static/media/profile-icon.4849db84.svg";